import { FC, SVGProps } from 'react'

export const Star: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M0 8C4.41785 8 8 11.5822 8 16C8 11.5822 11.5822 8 16 8C11.5822 8 8 4.41785 8 0C8 4.41785 4.41785 8 0 8Z"
      fill="currentColor"
    />
  </svg>
)
